/**
 * @brief Top버튼 컴포넌트
 * @details
 * @author hyekyoungKang
 * @date 2024-06-10
 * @version 0.0.1
 */

import React, { useEffect, useState } from "react";
import styles from "./TopButton.module.scss";
import UpSvg from "./../../../../assets/images/ScrollTop.svg";

const TopButton = () => {
  const [scrollY, setScrollY] = useState(0);
  const [showButton, setShowButton] = useState(false);

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    setScrollY(0); // ScrollY 의 값을 초기화
    setShowButton(false); // BtnStatus의 값을 false로 바꿈 => 버튼 숨김
  };

  useEffect(() => {
    const handleShowButton = () => {
      setScrollY(window.pageYOffset);
      if (window.scrollY > 500) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    // console.log(window.scrollY);
    window.addEventListener("scroll", handleShowButton);
    return () => {
      window.removeEventListener("scroll", handleShowButton);
    };
  }, []);

  return (
    showButton && (
      <div className={styles.container}>
        <button
          className={styles.topButton}
          onClick={scrollToTop}
          type="button"
        >
          <UpSvg width={24} height={20} fill={"#fff"} />
        </button>
      </div>
    )
  );
};

export default TopButton;
